import * as React from 'react'
import type { SVGProps } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTemplateIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 14 18"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#fff"
      d="M3.5 8.5v-1h7v1zm0-4v-1h7v1zm-2.5 7h7.5q.61 0 1.12.265.51.264.876.743L13 15.758V1.616a.6.6 0 0 0-.173-.443.6.6 0 0 0-.442-.173H1.615a.6.6 0 0 0-.442.173.6.6 0 0 0-.173.443zm.616 5.5h11.069L9.71 13.117a1.6 1.6 0 0 0-.536-.457 1.44 1.44 0 0 0-.674-.16H1v3.885q0 .27.173.442a.6.6 0 0 0 .443.173m10.769 1H1.615q-.69 0-1.152-.462T0 16.385V1.615Q0 .925.463.463A1.57 1.57 0 0 1 1.616 0h10.769q.69 0 1.153.463T14 1.616v14.769q0 .69-.462 1.153T12.385 18"
    />
  </svg>
)
export default SvgTemplateIcon
